import SoundtrackManageIndexComponent from './component';

class SoundtrackManageIndexRoute extends SoundtrackManageIndexComponent {

}

export default SoundtrackManageIndexRoute;
